export default __webpack_public_path__ + "static/media/img-38.3f8bbbda.jpg";